import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="bg-slate-950 py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-187" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-188" data-mp="j76soinpvto8">
        <SectionHeading id="summary-title" data-id="element-189" data-mp="j8880zbrn2br">Everything <span className="text-amber-400" data-id="element-190" data-mp="j5c7d38j9zjm">Included:</span></SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-2xl border border-slate-700 bg-slate-900 sm:grid-cols-2" data-id="element-191" data-mp="1gu5tn5lfznrx">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-slate-800 p-4 sm:odd:border-r" data-id="element-192" data-mp="16whmfg6ngnsv">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-amber-400" data-id="element-193" data-mp="12vxoiae95g5o">
                <CheckIcon className="h-3.5 w-3.5 text-slate-950" aria-hidden="true" data-id="element-194" data-mp="3ro1o5d26qbsa" />
              </span>
              <b className="text-sm text-white" data-id="element-195" data-mp="3nklsok1uqhh6">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}